export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6557.21e9afd4.jpg";